import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CcRequirementObjectProps,
    LoadCcRequirementVersions,
    setCcRequirementVersionList,
} from "client/store"
import {
    Container,
    PageContent,
    Loader,
    Table,
} from "client/components"

import Columns from "./columns"

const VersionList = ({
    requirement,
}: CcRequirementObjectProps) => {
    const requirementVersions = useSelector((state: StoreType) => state.ccRequirement.versionList)
    const versions = requirementVersions ? requirementVersions[requirement.id] : null
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadCcRequirementVersions(requirement.id).then((res) => {
            dispatch(setCcRequirementVersionList(requirement.id, res.versionIds, res.versionList))
        }).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    const columns = Columns()

    return (
        <Container>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <Table
                    columns={columns}
                    dataList={versions ? versions.versionList : {}}
                    dataIds={versions ? versions.versionIds : []}
                    showPagination
                />
            </PageContent>
        </Container>
    )
}
export default VersionList
